<p>
  {{ 'STEP1.INTRODUCTIONTEXT' | translate }}
</p>

<div style="margin: 20px"></div>
<app-isomasters-button (modularClick)="setPurpose(purposes.Cooling)" [selected]="purpose === purposes.Cooling">
  <div description>{{ 'STEP1.PURPOSE_COOLING' | translate }}</div>
</app-isomasters-button>
<app-isomasters-button (modularClick)="setPurpose(purposes.Freezing)" [selected]="purpose === purposes.Freezing">
  <div description>{{ 'STEP1.PURPOSE_FREEZING' | translate }}</div>
</app-isomasters-button>
<!-- <app-isomasters-button [selected]="purpose==purposes.Both" (modularClick)="setPurpose(purposes.Both)">
    <div description>{{'STEP1.PURPOSE_BOTH'|translate}}</div>
</app-isomasters-button> -->
